import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ApiService } from "../api.service";
import { environment } from "../../environments/environment";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class CandidateService {
  constructor(private http: HttpClient, private api: ApiService) {}

  createProfile(data: any) {
    return this.api.POST_BR(environment.CANDIDATE_APIS.createProfile, data);
  }
  getCountries(data: any) {
    return this.api.GET_BR(environment.CANDIDATE_APIS.getCountries, data);
  }
  emailVerification(data: any) {
    let key = data.verifyKey;
    return this.api.GET_BR(
      environment.CANDIDATE_APIS.emailVerification + "?verify_key=" + key,
      data
    );
  }

  createSubscription(data: any) {
    return this.api.POST_BR(
      environment.CANDIDATE_APIS.createSubscription,
      data
    );
  }

  getAllJobPostings(data: any) {
    return this.api.GET_BR(environment.CANDIDATE_APIS.getAllJobPostings, data);
  }

  forgotPassword(data: any) {
    return this.api.POST_BR(environment.CANDIDATE_APIS.forgotPassword, data);
  }
  createJobPosting(data: any) {
    return this.api.POST_BR(environment.CANDIDATE_APIS.createJobPosting, data);
  }
 
  updateJobPosting(data: any) {
    return this.api.POST_BR(environment.CANDIDATE_APIS.updateJobPosting, data);
  }

  validateUser(data: any) {
    return this.api.POST_BR(environment.CANDIDATE_APIS.validateUser, data);
  }

  changePassword(data: any) {
    return this.api.POST_BR(environment.CANDIDATE_APIS.changePassword, data);
  }
  getAllResumes(data: any): Observable<any> {
    return this.api.GET_BR(environment.CANDIDATE_APIS.getAllResumes, data);
  }
  getAdminDashboard(data: any): Observable<any> {
    return this.api.GET_BR(environment.CANDIDATE_APIS.getAdminDashboard, data);
  }
  updateProfile(data: any): Observable<any> {
    return this.api.POST_BR(environment.CANDIDATE_APIS.updateProfile, data);
  }
  getAllJobs(data: any): Observable<any> {
    return this.api.GET_BR(environment.CANDIDATE_APIS.getAllJobs, data);
  }
  getActiveFaqs(data: any): Observable<any> {
    return this.api.GET_BR(environment.CANDIDATE_APIS.getActiveFaqs, data);
  }
  createContactUs(data: any): Observable<any> {
    return this.api.POST_BR(environment.CANDIDATE_APIS.createContactUs, data);
  }
  getAllQualifications(data: any): Observable<any> {
    return this.api.GET_BR(environment.CANDIDATE_APIS.getAllQualifications, data);
  }
  getUserIndustries(data: any): Observable<any> {
    return this.api.GET_BR(environment.CANDIDATE_APIS.getUserIndustries, data);
  }
  getAllDesignations(data: any): Observable<any> {
    return this.api.GET_BR(environment.CANDIDATE_APIS.getAllDesignations, data);
  }

  active_blogs(data: any): Observable<any> {
    let nocache = data.nocache
    return this.api.GET_BR(environment.BLOG_APIS.active_blogs+"?nocache="+nocache, data);
  }
  getFAQs(data: any): Observable<any> {
    let application = data.application
    let module_name = data.module_name
    return this.api.GET_BR(environment.CMS_APIS.getFAQs+"?application="+application+"&module_name="+module_name, data);
  }
  getPolicyByName(data: any): Observable<any> {
    let name = data.name
    return this.api.GET_BR(environment.CMS_APIS.getPolicyByName+"?name="+name, data);
  }
  getSuccessStories(data: any): Observable<any> {
    
    return this.api.GET_BR(environment.CMS_APIS.getSuccessStories, data);
  }
  getTrustedClients(data: any): Observable<any> {
    
    return this.api.GET_BR(environment.CMS_APIS.getTrustedClients, data);
  }
  getAnonymousCandidateQuestionPaperByExamCode(data: any) {
    return this.api.POST_BR(environment.CANDIDATE_APIS.getAnonymousCandidateQuestionPaperByExamCode,data);
  }

  getSimilarJobs(data: any): Observable<any> {
    return this.api.POST_BR(environment.CANDIDATE_APIS.getSimilarJobs, data);
  }
  
}
